import { useQuery } from "@tanstack/react-query";
import eventsService from "services/admin/eventsService";

export const useGetEvents = (leadID: string) => {
    return useQuery({
        queryKey: ['events', leadID],
        queryFn: async () => {
            const response = await eventsService.getEvents(leadID)
            return response.data?.rows || []
        },
        refetchOnWindowFocus: false,
        enabled: !!leadID,
    })
}